import React from 'react';
import appTypes from '../../../../constants/types';
import SectionCard from '../../../../components/section-card';
import { TextDataField } from '../../../../components/data-fields';

export const OffboardingDetails = ({ ticket }) => (
  <>
    <SectionCard title="User Data">
      <TextDataField
        name="Jampper Email"
        value={ticket && ticket.ticket_data.email} />
      <TextDataField
        name="Manager Email"
        value={ticket && ticket.ticket_data.manager_email} />
      <TextDataField
        name="Date & Time"
        value={ticket && ticket.ticket_data.datetime} />
      <TextDataField
        name="Offboarding Type"
        value={
          ticket && typeof ticket.ticket_data.offboarding_type === 'string'
            ? (ticket.ticket_data.offboarding_type.charAt(0).toUpperCase() + ticket.ticket_data.offboarding_type.slice(1))
            : ''
        }
      />
    </SectionCard>
    
  </>
);

OffboardingDetails.propTypes = {
  ticket: appTypes.ticket.props,
};
OffboardingDetails.defaultProps = {
  ticket: appTypes.ticket.default,
};
